<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Login</h4>
                  <p class="mb-0">Ingresa usuario y password</p>
                </div>
                <div class="card-body">
                  <form role="form" @submit.stop.prevent="sendData">
                    <div class="mb-3">
                      <argon-input
                        id="usuario"
                        type="usuario"
                        placeholder="Usuario"
                        name="usuario"
                        v-model="model.usuario" 
                        size="lg"
                      />
                    </div>
                    <div class="mb-3">
                      <argon-input
                        id="password"
                        type="password"
                        placeholder="Password"
                        name="password"
                        v-model="model.password" 
                        size="lg"
                      />
                    </div>
                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                      >Entrar</argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Registrarse
                    <a href="#" @click.prevent="goto" class="text-success text-gradient font-weight-bold">
                      Registrarse
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg'); background-size: cover;"
              >
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "Sr Botana"
                </h4>
                <p class="text-white position-relative">
                  Plataforma de administracion de Sr Botana
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// import { onBeforeMount, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import usuario from "../api/usuario";
import Swal from "sweetalert2";

export default {
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      store: useStore(),
      model: {
        usuario: "",
        password: "",
      },
      body: null,
    };
  },
  mounted() {
    // Esto se ejecuta después de que el componente se monta
    this.store.state.hideConfigButton = true;
    this.store.state.showNavbar = false;
    this.store.state.showSidenav = false;
    this.store.state.showFooter = false;

    this.body = document.getElementsByTagName("body")[0];
    this.body.classList.remove("bg-gray-100");

    localStorage.clear();
  },
  beforeUnmount() {
    // Esto se ejecuta justo antes de que el componente se destruya
    this.store.state.hideConfigButton = false;
    this.store.state.showNavbar = true;
    this.store.state.showSidenav = true;
    this.store.state.showFooter = true;

    if (this.body) {
      this.body.classList.add("bg-gray-100");
    }
  },
  methods: {
    sendData() {
      usuario
        .logIn(this.model)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Login Correcto",
              text: "Login correcto",
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            localStorage.setItem("token", result.data.jwt);
            this.$router.push({ path: "/Dashboard" });
          } else {
            Swal.fire({
              title: "Error de Ingreso",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.model.usuario = "";
      this.model.password = "";
    },
    goto() {
      this.$router.push({ path: "/registro" });
    },
  },
};
</script>
